import { Action, ActionReducer, createReducer, on } from '@ngrx/store';
import { navigationMemoryActions } from './navigation-memory.actions';
import { INavigationMemoryState } from './types';

export const navigationMemoryInitialState: INavigationMemoryState = {
  key: '',
  payload: null,
  urlSource: '',
  urlTarget: '',
  hop: 0,
};

/** Compare two URLs ignoring the query string. */
export const sameRoute = (a: string, b: string): boolean =>
  a.split('?')[0] === b.split('?')[0];

const navigationMemoryReducers = [
  on(
    navigationMemoryActions.keep,
    (
      state: INavigationMemoryState,
      { key, payload, urlSource, urlTarget },
    ): INavigationMemoryState => ({
      key,
      payload,
      urlSource,
      urlTarget,
      hop: 0,
    }),
  ),
  on(
    navigationMemoryActions.updateHop,
    (state: INavigationMemoryState, { url }): INavigationMemoryState => {
      if (!state.key) return state; // not armed
      if (sameRoute(url, state.urlSource)) return state; // back to origin → consume decides
      if (sameRoute(url, state.urlTarget)) return state; // on intended target → no hop
      return { ...state, hop: state.hop + 1 }; // detour → +1
    },
  ),
  on(
    navigationMemoryActions.reset,
    (): INavigationMemoryState => navigationMemoryInitialState,
  ),
];

export const navigationMemoryReducer = createReducer(
  navigationMemoryInitialState,
  ...navigationMemoryReducers,
) as ActionReducer<INavigationMemoryState, Action>;

export function useReducerFunc(state: any | undefined, action: Action) {
  return navigationMemoryReducer(state, action);
}
